import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import useExecScripts from '../Component/useExecScripts'
import EnquiryForm from '../Component/EnquiryForm'
import EnquiryHeading from '../Component/EnquiryHeading'

function WeddingCateringMenu() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const containerRef = useExecScripts();

  return (
    <div id="content" className="site-content">
      <div className="ast-container">
        <div id="primary" className="content-area primary">
          <main id="main" className="site-main">
            <article className="page type-page status-publish ast-article-single">
              <header className="entry-header ast-no-thumbnail ast-no-title ast-header-without-markup"></header>
              <div ref={containerRef}>
                <div className="entry-content clear" itemProp="text">


                  <div data-elementor-type="wp-page" data-elementor-id="3479" className="elementor elementor-3479">
                    <div className="elementor-element elementor-element-b885253 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="b885253" data-element_type="container" data-e-type="container">
                      <div className="e-con-inner">
                        <div className="elementor-element elementor-element-3743ba2 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="3743ba2" data-element_type="container" data-e-type="container">
                          <div className="elementor-element elementor-element-55ed97d8 elementor-invisible elementor-widget elementor-widget-elementskit-image-box" data-id="55ed97d8" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="elementskit-image-box.default">
                            <div className="elementor-widget-container">
                              <div className="ekit-wid-con">
                                <div className="elementskit-info-image-box ekit-image-box text-center floating-style">


                                  <div className="elementskit-box-header image-box-img-center">

                                    <img decoding="async" src="/assets/uploads/elementor/thumbs/ANI03013-scaled-r2hvq4hiprfdgcq5hlx5x177qzpxprfum4zpvmr7lk.jpg" title="ANI03013" alt="ANI03013" loading="lazy" />
                                  </div>

                                  <div className="elementskit-box-body ekit-image-box-body">
                                    <div className="elementskit-box-content ekit-image-box-body-inner">
                                      <h3 className="elementskit-info-box-title">

                                        Buffet Catering with service

                                      </h3>
                                    </div>

                                    <div className="elementskit-box-footer">
                                      <div className="box-footer">
                                        <div className="btn-wraper">
                                          <Link className="elementskit-btn whitespace--normal" to="/buffet-catering">
                                            Explore more
                                            <i aria-hidden="true" className="icon icon-arrow-right"></i>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>				</div>
                          </div>
                        </div>
                        <div className="elementor-element elementor-element-02f4542 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="02f4542" data-element_type="container" data-e-type="container">
                          <div className="elementor-element elementor-element-29f9c229 elementor-invisible elementor-widget elementor-widget-elementskit-image-box" data-id="29f9c229" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="elementskit-image-box.default">
                            <div className="elementor-widget-container">
                              <div className="ekit-wid-con">
                                <div className="elementskit-info-image-box ekit-image-box text-center floating-style">


                                  <div className="elementskit-box-header image-box-img-center">

                                    <img decoding="async" src="/assets/uploads/elementor/thumbs/ANI07677-scaled-r2hvsai4h0e67zktu1n75zih1z1egn1kkv50pljj94.jpg" title="ANI07677" alt="ANI07677" loading="lazy" />
                                  </div>

                                  <div className="elementskit-box-body ekit-image-box-body">
                                    <div className="elementskit-box-content ekit-image-box-body-inner">
                                      <h3 className="elementskit-info-box-title">

                                        For 4 to 40 Guests  ( Delivery Services)

                                      </h3>
                                    </div>

                                    <div className="elementskit-box-footer">
                                      <div className="box-footer">
                                        <div className="btn-wraper">
                                          <Link className="elementskit-btn whitespace--normal" to="/delivery-services">
                                            Explore more
                                            <i aria-hidden="true" className="icon icon-arrow-right"></i>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>				</div>
                          </div>
                        </div>
                        <div className="elementor-element elementor-element-178382e e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="178382e" data-element_type="container" data-e-type="container">
                          <div className="elementor-element elementor-element-c5686e8 elementor-widget__width-initial elementor-invisible elementor-widget elementor-widget-elementskit-image-box" data-id="c5686e8" data-element_type="widget" data-e-type="widget" data-settings='{"_animation":"fadeInUp"}' data-widget_type="elementskit-image-box.default">
                            <div className="elementor-widget-container">
                              <div className="ekit-wid-con">
                                <div className="elementskit-info-image-box ekit-image-box text-center floating-style">


                                  <div className="elementskit-box-header image-box-img-center">

                                    <img decoding="async" src="/assets/uploads/elementor/thumbs/WordPress-Coming-Soon-Page-Plugins-r53uzo7lj13658zqcroqncgwr13yby9gk127i6bfi0.png" title="WordPress-Coming-Soon-Page-Plugins" alt="WordPress-Coming-Soon-Page-Plugins" loading="lazy" />
                                  </div>

                                  <div className="elementskit-box-body ekit-image-box-body">
                                    <div className="elementskit-box-content ekit-image-box-body-inner">
                                      <h3 className="elementskit-info-box-title">

                                        Mini Buffet

                                      </h3>
                                    </div>

                                    <div className="elementskit-box-footer">
                                      <div className="box-footer">
                                        <div className="btn-wraper">
                                          <Link className="elementskit-btn whitespace--normal" to="/buffet-catering">
                                            Explore more
                                            <i aria-hidden="true" className="icon icon-arrow-right"></i>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>				</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="elementor-element elementor-element-7c6477b3 e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-parent" data-id="7c6477b3" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
                      <div className="elementor-element elementor-element-20db230 e-flex e-con-boxed wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="20db230" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
                        <div className="e-con-inner">
                          <div className="elementor-element elementor-element-178a22de e-con-full e-flex wpr-particle-no wpr-jarallax-no wpr-parallax-no wpr-sticky-section-no wpr-column-slider-no wpr-equal-height-no e-con e-child" data-id="178a22de" data-element_type="container" data-e-type="container" data-settings='{"background_background":"classic"}'>
                                                        <EnquiryHeading widgetElementId="1a81c654" />

                                                        <EnquiryForm widgetElementId="475e0482" />

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </article>
          </main>
        </div>
      </div>
    </div>
  )
}

export default WeddingCateringMenu
